var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartNotSelected = function SvgChartNotSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.16666667 3.5h.16666666c.64166667 0 1.16666667.525 1.16666667 1.16666667v5.83333333c0 .6416667-.525 1.1666667-1.16666667 1.1666667h-.16666666c-.64166667 0-1.16666667-.525-1.16666667-1.1666667v-5.83333333c0-.64166667.525-1.16666667 1.16666667-1.16666667zm4.66666666-3.5c.64166667 0 1.16666667.525 1.16666667 1.16666667v9.33333333c0 .6416667-.525 1.1666667-1.16666667 1.1666667-.64166666 0-1.16666666-.525-1.16666666-1.1666667v-9.33333333c0-.64166667.525-1.16666667 1.16666666-1.16666667zm4.66666667 6.66666667c.6416667 0 1.1666667.525 1.1666667 1.16666666v2.66666667c0 .6416667-.525 1.1666667-1.1666667 1.1666667-.64166667 0-1.16666667-.525-1.16666667-1.1666667v-2.66666667c0-.64166666.525-1.16666666 1.16666667-1.16666666z",
    transform: "translate(4.166667 4.166667)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartNotSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart_not_selected.0c911251.svg";
export { ForwardRef as ReactComponent };